import styled from "styled-components";

export const Title = styled.h1`
  font-size: 1.3rem;
  font-weight: bolder;
  color: #f3f3f3;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  @media (min-width: 769px) {
    flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;

  }
`;

export const GeneralJobs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;

export const ItemJob = styled.div`
  display: flex;
  gap: 0.5rem;
  box-sizing: content-box;
`;
